module.exports = "/_next/static/media/639df9dc03aa1caf2e9cc9faba4ff2e0.svg";